
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.012 5.012a2 2 0 012-2.012h9.09a2 2 0 011.495.671l2.898 3.26A2 2 0 0120 8.262V19a2 2 0 01-2 2H6.093a2 2 0 01-2-1.988l-.081-14z","fill":"#AAA"}}),_c('path',{attrs:{"d":"M8.035 9.533A.5.5 0 018.534 9H15.5a.5.5 0 010 1H8.534a.5.5 0 01-.5-.467zM8.035 12.533A.5.5 0 018.534 12H15.5a.5.5 0 010 1H8.534a.5.5 0 01-.5-.467zM8.021 15.52a.5.5 0 01.5-.52H12.5a.5.5 0 010 1H8.52a.5.5 0 01-.499-.48z","fill":"#fff"}})])
          )
        }
      }
    